import { combineReducers } from 'redux';
import supportReducer from './support/reducer';

const rootReducer = combineReducers({
    support: supportReducer,
});

export default rootReducer;
